<script setup lang="ts">
/** Announcements with display=banner — dismissible strips above the content. */
import type { AnnouncementItem } from '~/utils/announcements'

defineProps<{ items: AnnouncementItem[] }>()
const emit = defineEmits<{ (e: 'dismiss', item: AnnouncementItem): void; (e: 'cta', item: AnnouncementItem): void }>()
</script>

<template>
  <div v-for="a in items" :key="a.id" class="anb" :class="`anb--${a.kind}`" role="status">
    <span class="anb__text">
      <strong>{{ a.title }}</strong>
      <template v-if="a.body"> — {{ a.body }}</template>
    </span>
    <button v-if="a.cta_url" type="button" class="anb__cta" @click="emit('cta', a)">
      {{ a.cta_label || 'Otevřít' }}
    </button>
    <button type="button" class="anb__close" aria-label="Zavřít" @click="emit('dismiss', a)">×</button>
  </div>
</template>

<style scoped>
.anb {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  background: #eef0fa;
  border-bottom: 1px solid #d5dbf2;
  color: #243179;
  font-size: 13px;
}
.anb--success {
  background: #e9f5ee;
  border-bottom-color: #c6e3d1;
  color: #1f5a37;
}
.anb--warning {
  background: #fff4dc;
  border-bottom-color: #ecd39a;
  color: #6b4a07;
}
.anb__text {
  flex: 1;
  min-width: 0;
  white-space: pre-line;
  overflow-wrap: anywhere;
}
.anb__cta {
  flex: none;
  border: 1px solid currentColor;
  background: #fff;
  color: inherit;
  font-size: 12.5px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 999px;
  cursor: pointer;
  font-family: inherit;
}
.anb__close {
  flex: none;
  border: none;
  background: transparent;
  color: inherit;
  opacity: 0.7;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  padding: 2px 6px;
}
.anb__close:hover {
  opacity: 1;
}
</style>
